<div class="container">
  <div class="row">
    <div class="col">
      <div class="video-section__container mx-auto">
        <h2>Real voices, real T1D experience.</h2>
        <p class="mb-4">
          Watch our collection of stories that drive home the importance of T1D
          awareness and screening, from both professional and patient
          perspectives.
        </p>
        <div
          video-carousel
          [videoCarouselData]="videoData"
          [transcript]="true"
          class="text-gray-900"
        ></div>
      </div>
    </div>
  </div>
</div>


